export default __webpack_public_path__ + "static/media/IconSnapchat.46b095f8.svg";